const PRODUCT_TRANSLATION_GROUPS = new Set([
    'auth',
    'client',
    'lib',
    'offResqCustomer',
    'ops',
    'vendor',
]);

export const SHARED_TRANSLATION_GROUP = 'shared';

export const getTranslationGroup = (namespace: string): string => {
    const [group] = namespace.split('.');
    return group && PRODUCT_TRANSLATION_GROUPS.has(group) ? group : SHARED_TRANSLATION_GROUP;
};
